import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { MainStoreState } from 'store/MainStoreState';

export const useMainSelector: TypedUseSelectorHook<MainStoreState> =
  useSelector;
